module.exports = __webpack_public_path__ + "static/engineeringStory4-aed2417c7e76aa7688f074e7fb588160.jpg";